import { type FC } from 'react';
import { Icon } from '../../../../ui/Icon';
import { IconUserBonefish } from '@maverick/icons/dist/IconUserBonefish';
import { ReturnIcon } from '@maverick/icons/dist/ReturnIcon';
import { useRouter } from 'next/navigation';

import styles from './DashboardHeaderMobile.module.scss';

interface DashboardHeaderMobileProps {
	isSubpage: boolean;
	setMenuClicked: (value: boolean) => void;
}
export const DashboardHeaderMobile: FC<DashboardHeaderMobileProps> = ({ isSubpage, setMenuClicked }) => {
	const router = useRouter();

	const handleMobileHeaderBack = () => {
		if (isSubpage) {
			router.push('/dashboard');
		} else {
			setMenuClicked(true);
			window.location.hash = '';
			window.dispatchEvent(new HashChangeEvent('hashchange'));
		}
	};

	const handleClickMemberProfile = () => {
		router.push('/dashboard/member-profile');
	};

	if (isSubpage) {
		return null;
	}

	return (
		<div className={styles['container']}>
			<div className={styles['icon-back']} onClick={handleMobileHeaderBack}>
				<Icon icon={ReturnIcon} />
			</div>
			<div
				data-testid='dine-rewards-logo'
				className={styles['logo']}
				tabIndex={0}
				aria-label='Dine Rewards Logo'
			/>
			<div data-testid='header-member-profile-icon' id='header-member-profile-icon' className={styles['user']}>
				<div onClick={handleClickMemberProfile} aria-label='Member profile'>
					<Icon icon={IconUserBonefish} customSize />
				</div>
			</div>
		</div>
	);
};
